import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Строка настройки: объяснение слева, орган управления справа.
 *
 * Заводится потому, что тумблер пробовали поставить в слот знака у
 * `CardHeading` — а тот держит СВОИ знаки ростом ровно в первую строку
 * заголовка, и тумблер сплющивало до 19 px вместо 26. Место знака и место
 * органа управления — разные места, и одним слотом их не выразить.
 *
 * Управление стоит рядом со ВСЕМ левым столбцом, а не только с подписью:
 * под подписью идёт то же значение словами, и оно относится к тумблеру не
 * меньше самой подписи.
 */
export function SettingRow({ control, children }: { control: ReactNode; children: ReactNode }) {
  return (
    <div className={styles.settingRow}>
      <div className={styles.settingBody}>{children}</div>
      <span className={styles.settingControl}>{control}</span>
    </div>
  );
}
